/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Write: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.0003 0.584961L17 3.58522L20.4139 6.99913L23.4142 3.99887L20.0003 0.584961ZM19 22.9998H2C1.73478 22.9998 1.48043 22.8944 1.29289 22.7069C1.10536 22.5193 1 22.265 1 21.9998V4.99977C1 4.73455 1.10536 4.4802 1.29289 4.29266C1.48043 4.10512 1.73478 3.99977 2 3.99977H10V5.99977H3V20.9998H18V13.9998H20V21.9998C20 22.265 19.8946 22.5193 19.7071 22.7069C19.5196 22.8944 19.2652 22.9998 19 22.9998ZM8.12595 12.4598L15.5859 4.99977L18.9999 8.41377L11.5399 15.8738L6.41895 17.5808L8.12595 12.4598Z'
      fill='currentColor'
    />
  </React.Fragment>
)
